(function () {
    angular
        .module('seven-admin.auth')
        .factory('AuthService', ['$http', 'appSettingsSvc', function ($http, appSettingsSvc) {
            var userLoggedIn = false;

            function verifyUserAccount(data) {
                var url =  appSettingsSvc.urls.api + '/admin/users/activate.json';

                return $http({
                    url: url,
                    method: 'PUT',
                    data: data
                }).then(function (response) {
                    return response;
                }, function (error) {
                    return error;
                });
            }

            return {
                verifyUserAccount: verifyUserAccount
            }
        }])

}());

;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('DeviceInstallController', DeviceInstallController);

    DeviceInstallController.$inject = ['$scope', '$state', '$location', 'betshopSvc', 'notificationService', '$translate'];

    function DeviceInstallController($scope, $state, $location, betshopSvc, notificationService, $translate) {

        $scope.pageAction = 'device-install';

        $scope.installData = {
            code: '',
            deviceUuid: $location.search()['uuid'],
            discoveryCode: $location.search()['discoveryCode']
        };

        $scope.showInstallLoader = false;

        $scope.viewList = {
            'dialogs': 'yes',
            'type': 'general'
        };

        $scope.infoMessages = {
            'success-general': {
                'type': 'info',
                'display': 'no',
                'title': 'Success',
                'content': 'Device installed'
            },
            'error-general': {
                'type': 'error',
                'display': 'no',
                'title': 'Error',
                'content': ''
            }
        };

        $translate.use('en').then(function () {
            var translationKeys = [
                'general.success',
                'general.error',
                'device.installed'
                ],
                translations = $translate.instant(translationKeys);

            $scope.infoMessages['success-general'].title = translations['general.success'];
            $scope.infoMessages['success-general'].content = translations['device.installed'];
            $scope.infoMessages['error-general'].title = translations['general.error'];
        });

        var deviceInfo = JSON.parse(localStorage.getItem('deviceInfo'));

        if (!deviceInfo) {
            $scope.installData = {
                code: '',
                deviceUuid: $location.search()['uuid'],
                discoveryCode: $location.search()['discoveryCode']
            };
        } else {
            $scope.installData = {
                code: deviceInfo.code,
                deviceUuid: deviceInfo.deviceUuid,
                discoveryCode: deviceInfo.discoveryCode
            };

            $location.search('uuid', deviceInfo.deviceUuid);
            $location.search('discoveryCode', deviceInfo.discoveryCode);
        }

        $scope.deviceIpAdress = $location.search()['ipAddress'];

        $scope.installDevice = function () {
            $scope.showInstallLoader = true;
            betshopSvc.installDeviceFromCode($scope.installData).then(function (response) {
                $scope.showInstallLoader = false;
                if (notificationService.serverResponseValid(response.status)) {
                    $scope.infoMessages['error-general'].display = 'no';
                    if (deviceInfo) {
                        localStorage.removeItem('deviceInfo');
                    }
                    notificationService.showInfoNotification($scope.infoMessages['success-general'], 10000)
                } else {
                    $scope.infoMessages['error-general'].content = response.data.message;
                    notificationService.showInfoNotification($scope.infoMessages['error-general'], 0)
                }
            });
        };

        $scope.goToLogin = function () {
            localStorage.setItem('deviceInfo', JSON.stringify($scope.installData));
            $state.go('login');
        };

        $scope.activeFormName = 'deviceInstallForm_1';
    }
}());
;
(function () {
    angular
        .module('seven-admin.auth')
        .controller('ForbiddenPageController', ForbiddenPageController);

    ForbiddenPageController.$inject = ['$rootScope', 'appSettingsSvc', 'companyIdentitySvc', '$filter', '$scope', '$state', '$translate', '$window', 'userInitData']

    function ForbiddenPageController($rootScope, appSettingsSvc, companyIdentitySvc, $filter, $scope, $state, $translate, $window, userInitData) {
        var firstModule = $filter('orderObjectBy')(appSettingsSvc.modules, 'priority')[0];

        $scope.firstModule = {
            name: firstModule.name,
            state: firstModule.state
        };
        $scope.forbiddenMessage = $translate.instant('general.forbidden_msg');
        $scope.forbiddenError = $rootScope.forbiddenError;
        $scope.forbiddenEntityCompany = {};
        $scope.lastCompany = {};

        if ($scope.forbiddenError) {
            if ($scope.forbiddenError.details) {
                $scope.forbiddenEntityCompany = _.find(userInitData.user.companies, function (company) {
                    return company.uuid === $rootScope.forbiddenError.details.entityCompanyUuid;
                });
                $scope.forbiddenEntityCompany.perceivedAsCurrnet = $scope.forbiddenEntityCompany.uuid === userInitData.currentCompany.uuid;

                $scope.lastCompany = _.find(userInitData.user.companies, function (company) {
                    return company.uuid === $rootScope.forbiddenError.details.userCompanyUuid;
                });
                $scope.lastCompany.perceivedAsCurrnet = $scope.lastCompany.uuid === userInitData.currentCompany.uuid;
            }

            if ($rootScope.forbiddenError.code === 19000) {
                $scope.forbiddenMessage = $translate.instant('msg.companies_no_match_error')
            }
        }

        $scope.switchCompany = function (companyId, state) {
            companyIdentitySvc.switchCompany(companyId)
                .then(function () {
                    $state.get(state).data['forceReload'] = true;
                    $state.go(state, {}, {reload: true}).then(function () {
                        $window.location.reload();
                        $rootScope.forbiddenError = null;
                    });
                });
        };

        $scope.previousPage = function () {
            $state.go(firstModule.state);
        };
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('LoginSwitchController', LoginCompanySwitchController);

    LoginCompanySwitchController.$inject = [
        '$scope',
        '$timeout',
        '$window',
        '$stateParams',
        'NabAuth',
        'tokenAuthService'
    ];

    function LoginCompanySwitchController ($scope, $timeout, $window, $stateParams, NabAuth, tokenAuthService) {
        var storedSetting = JSON.parse(localStorage.getItem('settings'));
        $scope.availableCompanies = $stateParams.companies;

        $scope.loginToCompany = function (companyUuid) {
            var config = { headers : {'SEVEN-COMPANY-UUID': companyUuid}},
                loginData = {
                _username: $stateParams.username,
                _password: $stateParams.password
            };

            NabAuth.login(loginData, config).then(function (response) {
                if (NabAuth.loggedIn) {
                    if ($scope.rememberUser) {
                        storedSetting.storedUser = NabAuth.data.user.email;
                        localStorage.setItem('settings', JSON.parse(storedSetting))
                    }
                    localStorage.setItem('firstLogin', true);

                    $timeout( function () {
                        $window.location.reload();
                    }, 500);
                }
            });
        };
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('ForgotPassController', ForgotPassController);

    ForgotPassController.$inject = ['$scope', '$state', '$stateParams', '$translate', 'NabAuth'];

    function ForgotPassController($scope, $state, $stateParams, $translate, NabAuth) {
        var NONEXISTENT_USER = 12001;
        var RESET_LINK_ALREADY_SENT = 12025;
        var PASSWORD_RESET_NOT_ALLOWED = 12024;

        $scope.dialogs = {
            'forgot-password': {
                'name': 'Forgot password',
                'type': 'form',
                'display': 'yes',
                'negativeActionText': 'Cancel',
                'positiveActionText': 'Send',
                'negativeActionCallback': 'cancelRequest',
                'positiveActionCallback': 'sendEmail',
                'canProceed': 'no',
                'formEmpty': 'yes',
                'actionBar': 'yes',
                'viewContent': {
                    'type': 'form',
                    'showFieldNames': 'no',
                    'name': 'loginForm_1',
                    'autocomplete': 'off',
                    'fields': [
                        {
                            'name': 'Email',
                            'placeholder': 'Email',
                            'id': 'forgot',
                            'classes': 'form-control input-md',
                            'type': 'email',
                            'required': 'yes',
                            'error': 'Empty or invalid email.'
                        }]
                }
            },
            'reset-password': {
                'display': 'no',
                'type': 'form',
                'name': 'Reset Password',
                'negativeActionText': 'Cancel',
                'positiveActionText': 'Reset',
                'negativeActionCallback': 'cancelRequest',
                'positiveActionCallback': 'resetPassword',
                'canProceed': 'no',
                'formEmpty': 'yes',
                'actionBar': 'yes',
                'viewContent': {
                    'type': 'form',
                    'showFieldNames': 'no',
                    'name': 'loginForm_2',
                    'autocomplete': 'off',
                    'fields': [
                        {
                            'name': 'oldPass',
                            'placeholder': 'Password',
                            'id': 'oldPass',
                            'classes': 'form-control input-md',
                            'type': 'password',
                            'required': 'yes',
                            'minlength': '8',
                            'maxlength': '255',
                            'pattern': /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$/,
                            'error': 'Empty or invalid password. Length must be between 8 and 20 chars.'
                        },
                        {
                            'name': 'newPass',
                            'placeholder': 'Repeat password',
                            'id': 'newPass',
                            'classes': 'form-control input-md',
                            'type': 'password',
                            'required': 'yes',
                            'minlength': '8',
                            'maxlength': '255',
                            'error': 'Empty or invalid password.',
                            'dependency': 'oldPass',
                            'dependencyError': 'Passwords do not match'
                        }]
                }
            }
        };

        $translate.use('en').then(function () {
            var translationKeys =
                [
                    'general.invalid_email_format',
                    'error.validation.passwords_nomatch',
                    'general.cancel',
                    'general.send',
                    'general.email',
                    'general.forgot_password',
                    'general.reset',
                    'general.password',
                    'general.repeat_password',
                    'general.reset_password'
                ],
                translations = $translate.instant(translationKeys);

            $scope.dialogs['forgot-password'].name = translations['general.forgot_password'];
            $scope.dialogs['forgot-password'].positiveActionText = translations['general.send'];
            $scope.dialogs['forgot-password'].negativeActionText = translations['general.cancel'];
            $scope.dialogs['forgot-password'].viewContent.fields[0].placeholder = translations['general.email'];
            $scope.dialogs['forgot-password'].viewContent.fields[0].error = translations['general.invalid_email_format'];

            $scope.dialogs['reset-password'].name = translations['general.reset_password'];
            $scope.dialogs['reset-password'].positiveActionText = translations['general.reset'];
            $scope.dialogs['reset-password'].negativeActionText = translations['general.cancel'];
            $scope.dialogs['reset-password'].viewContent.fields[0].placeholder = translations['general.password'];
            $scope.dialogs['reset-password'].viewContent.fields[0].error = $translate.instant('error.validation.empty_password_or_invalid_length_and_char_match', {min: 8});

            $scope.dialogs['reset-password'].viewContent.fields[1].placeholder = translations['general.repeat_password'];
            $scope.dialogs['reset-password'].viewContent.fields[1].error = $translate.instant('error.validation.empty_password_or_invalid_length_and_char_match', {min: 8});
            $scope.dialogs['reset-password'].viewContent.fields[1].dependencyError = translations['error.validation.passwords_nomatch'];
        });

        $scope.activeFormName = '';

        $scope.viewList = {
            'dialogs': 'yes',
            'type': 'general'
        };

        $scope.fieldValues = {};

        $scope.oldFieldData = {};

        $scope.$watch('fieldValues', function (newData) {
            $scope.newFieldData = newData;
            $scope.tmpPassword = ($scope.fieldValues.oldPass === $scope.fieldValues.newPass) ? $scope.fieldValues.oldPass : '';
        }, true);

        $scope.$on('actionBar:cancelRequest', function () {
            $state.go('login', {}, {reload: true});
        });

        $scope.negativeAction = function () {
            $state.go('login', {}, {reload: true});
        };

        $scope.changeInProgress = {'active': false};

        $scope.$on('actionBar:sendEmail', function () {
            $scope.changeInProgress.active = true;
            NabAuth.resetPasswordRequest($scope.fieldValues.forgot).then(function (response) {
                if ([200, 201, 204].indexOf(NabAuth.response.status) !== -1) {
                    $state.go('reset', {'type': 'email'}, {reload: true});
                } else if (NabAuth.response.status === 400 && NabAuth.response.data.code === NONEXISTENT_USER) {
                    $state.go('reset', {'type': 'unregistered'}, {reload: true});
                } else if (NabAuth.response.status === 400 && NabAuth.response.data.code === RESET_LINK_ALREADY_SENT) {
                    $state.go('reset', {'type': 'sent'}, {reload: true});
                } else if (NabAuth.response.status === 400 && NabAuth.response.data.code === PASSWORD_RESET_NOT_ALLOWED) {
                    $state.go('reset', {type: 'disallowed'}, {reload: true})
                }else {
                    $state.go('reset', {'type': 'error'}, {reload: true});
                }
                $scope.changeInProgress.active = false;
            });

        });

        $scope.activeFormName = 'loginForm_1';

        if ($stateParams.token) {
            $scope.dialogs['forgot-password'].display = 'no';
            $scope.dialogs['reset-password'].display = 'yes';
            $scope.activeFormName = 'loginForm_2';
        }

        $scope.$on('actionBar:resetPassword', function () {
            if ($scope.fieldValues.oldPass === $scope.fieldValues.newPass) {
                $scope.changeInProgress.active = true;
                NabAuth.resetPassword($stateParams.token, $scope.fieldValues.oldPass).then(function () {
                    if ([200, 201, 204].indexOf(NabAuth.response.status) !== -1) {
                        $state.go('reset', {'type': 'success'}, {reload: true});
                    } else {
                        $state.go('reset', {'type': 'token-error'}, {reload: true});
                    }
                    $scope.changeInProgress.active = false;
                });
            }
        });
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('LogoutController', LogoutController);

    LogoutController.$inject = ['$window', 'tokenAuthService','NabAuth'];

    function LogoutController ($window, tokenAuthService, NabAuth) {
        NabAuth.logout().then(function () {
            tokenAuthService.removeTokens();

            if (!NabAuth.loggedIn){
                $window.location.reload();
            }
        });
    }
}());
;
(function () {
    angular
        .module('seven-admin.auth')
        .controller('ResetPassController', ResetPassController);

    ResetPassController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$translate'
    ];

    function ResetPassController(
        $scope,
        $state,
        $stateParams,
        $translate
    ) {
        $translate.use('en').then(function () {
            var message = {
                email: $translate.instant('general.email_sent'),
                unregistered: $translate.instant('general.invalid_email'),
                sent: $translate.instant('general.reset_link_already_sent'),
                success: $translate.instant('general.password_reset_success_check_email'),
                'token-error': $translate.instant('general.invalid_token_check_email'),
                error: $translate.instant('general.something_went_wrong'),
                disallowed: $translate.instant('general.password_reset_not_allowed')
            };

            $scope.resetPassMessage = message[$stateParams.type];

            setTimeout(function () {
                $state.go('login');
            }, 5000);
        });
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$scope', '$state', '$window', '$interval', '$timeout', '$stateParams', 'NabAuth', '$translate', 'tokenAuthService', 'auditSvc', 'appSettingsSvc', 'zodiacSocketConnection'];

    function LoginController ($rootScope, $scope, $state, $window, $interval, $timeout, $stateParams, NabAuth, $translate, tokenAuthService, auditSvc, appSettingsSvc, zodiacSocketConnection) {
        var storedSettings = JSON.parse(localStorage.getItem('settings'));

        $translate.use('en');

        $scope.isLoggedIn = false;
        $scope.submitted = false;
        $scope.deviceMode = false;
        $scope.pageAction = 'login';

        $scope.setSubmit = function () {
            $scope.submitted = true;
        };

        // Login form has remember username functionality
        if (storedSettings && storedSettings.storedUser && storedSettings.storedUser !== '') {
            $scope.rememberUser = true;
            $scope.username = storedSettings.storedUser;
        } else {
            $scope.rememberUser = false;
        }

        if ($stateParams.usr) {
            $scope.username = $stateParams.usr;
        }

        if (localStorage.getItem('deviceInfo')) {
            $scope.deviceMode = true;
        }

        $scope.login = function (username, password) {
            if (!$scope.rememberUser && storedSettings) {
                delete storedSettings.storedUser;
                localStorage.setItem('settings', JSON.stringify(storedSettings));
            }

            $scope.showLoginLoader = true;
            $rootScope.loginInfoMsg = '';

            var loginObj = {
                _username: username,
                _password: password
            };

            NabAuth.login(loginObj).then(function (response, config, headers) {
                $scope.showLoginLoader = false;

                if (NabAuth.loggedIn) {
                    if ($scope.rememberUser) {
                        storedSettings.storedUser = NabAuth.data.user.email;
                        localStorage.setItem('settings', JSON.stringify(storedSettings));
                    }

                    var accessToken = response.headers('Access-Token');
                    var refreshToken = response.headers('X-NSFT-IAM-REFRESH-TOKEN');
                    tokenAuthService.setTokens(accessToken, refreshToken);

                    localStorage.setItem('firstLogin', true);
                    localStorage.setItem('refreshUserBootstrap', true);

                    auditSvc.preparePostInitAuditRecordPayload({
                        url: appSettingsSvc.loginApi.normal,
                        method: 'POST',
                        domain: 'Administrators',
                        resourceType: 'UserLogin',
                        resourceId: NabAuth.data.user.id,
                        resourceDisplayId: NabAuth.data.user.email,
                        context: {
                            username: NabAuth.data.user.email
                        },
                        audit: true
                    });

                    $timeout( function () {
                        $window.location.reload();
                    }, 500);
                    // reload is needed to properly load the app, timeout is needed for localstorage to save corectly
                } else {
                    setErrorLoginMsg(response.data.message || 'Login failed, try again!');

                    // Status code when user's IP is blacklisted
                    if (response.status === 401 && response.data.code && response.data.code === 12025) {
                        $timeout( function() {
                            $state.go('loginCompanySwitch', {
                                username: username,
                                password: password,
                                companies: response.data.details
                            });
                        }, 1000)
                    } else if (response.status === 403) {
                        setErrorLoginMsg('Login for that user is currently disabled.');
                    }
                }
            });
        };

        function setErrorLoginMsg(msg) {
            $rootScope.loginInfoMsg = '';
            $timeout(function(){
                $rootScope.loginInfoMsg = msg;
            }, 200);
        }

        function handleLogout (auditData)  {
            tokenAuthService.removeTokens();
            $rootScope.loginInfoMsg = '';
            auditSvc.record(auditData);
            // reload after some delay so we don't cancel audit http request
            $timeout( function () {
                $window.location.reload();
            }, 500);
        }

        $scope.goBackToDeviceInstall = function (event) {
            $state.go('deviceInstall', {}, {});
        };

        $scope.logout = function () {
            const auditData = {
                url: `${appSettingsSvc.urls.api}/logout`,
                method: 'GET',
                domain: 'Administrators',
                resourceType: 'UserLogout',
                resourceId: NabAuth.data.user.id,
                resourceDisplayId: NabAuth.data.user.email,
                context: {
                    username: NabAuth.data.user.email
                },
                audit: true
            };
            NabAuth.logout().then(function () {
                try {
                    if (zodiacSocketConnection.isConnected()) {
                        zodiacSocketConnection.changeOnlineStatus({
                            online: false
                        });
                        zodiacSocketConnection.disconnect();
                    }
                    handleLogout(auditData);
                } catch (e) {
                    handleLogout(auditData)
                }
            });
        };

        $scope.loginOauth = function(provider) {
            NabAuth.oAuth(provider);
            $rootScope.loginInfoMsg = '';
            localStorage.setItem('oAuthLogin', true);
            localStorage.setItem('oAuthLoginAudit', true);
        };
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .controller('VerifyAccountController', VerifyAccountController);

    VerifyAccountController.$inject = ['$scope', '$state', '$stateParams', '$location', '$timeout', 'AuthService', '$translate'];

    function VerifyAccountController($scope, $state, $stateParams, $location, $timeout, AuthService, $translate) {

        $scope.dialogs = {
            'enter-password': {
                'display': 'no',
                'type': 'form',
                'name': 'Enter Password',
                'negativeActionText': 'Cancel',
                'positiveActionText': 'Activate',
                'negativeActionCallback': 'cancelRequest',
                'positiveActionCallback': 'setPassword',
                'canProceed': 'no',
                'formEmpty': 'yes',
                'actionBar': 'yes',
                'viewContent': {
                    'type': 'form',
                    'showFieldNames': 'no',
                    'name': 'loginForm_2',
                    'autocomplete': 'off',
                    'fields': [
                        {
                            'name': 'password',
                            'placeholder': 'Password',
                            'id': 'password',
                            'classes': 'form-control input-md',
                            'type': 'password',
                            'pattern': /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).+$/,
                            'minlength': '8',
                            'maxlength': '255'
                        },
                        {
                            'name': 'passwordRepeat',
                            'placeholder': 'Repeat password',
                            'id': 'passwordRepeat',
                            'classes': 'form-control input-md',
                            'type': 'password',
                            'error': 'Password can\'t be empty and must contain at least 8 characters - uppercase, lowercase letters, and numbers allowed.',
                            'dependency': 'password',
                            'dependencyError': 'Passwords do not match'
                        }]
                }
            }
        };

        $scope.infoMessages = {
            'password-success': {
                'display': 'no',
                'type': 'info',
                'title': 'Success',
                'content': 'Password successfully created. You can now login with your user information. Redirecting...'
            },
            'server-error': {
                'display': 'no',
                'type': 'error',
                'title': 'Error',
                'content': 'There was an error while creating your password.'
            },
            'invalid-input': {
                'display': 'no',
                'type': 'error',
                'title': 'Error',
                'content': 'Please enter a valid password.'
            }
        };

        $scope.viewList = {
            'dialogs': 'yes',
            'type': 'general'
        };

        $translate.use('en').then(function () {
            var translationKeys =
                    [
                        'error.validation.passwords_nomatch',
                        'general.activate',
                        'general.cancel',
                        'general.enter_password',
                        'general.password',
                        'general.repeat_password'
                    ],
                translations = $translate.instant(translationKeys);

            $scope.dialogs['enter-password'].name = translations['general.enter_password'];
            $scope.dialogs['enter-password'].negativeActionText = translations['general.cancel'];
            $scope.dialogs['enter-password'].positiveActionText = translations['general.activate'];
            $scope.dialogs['enter-password'].viewContent.fields[0].placeholder = translations['general.password'];
            $scope.dialogs['enter-password'].viewContent.fields[0].error = $translate.instant('error.validation.empty_password_or_invalid_length_and_char_match', {min: 8});
            $scope.dialogs['enter-password'].viewContent.fields[1].placeholder = translations['general.repeat_password'];
            $scope.dialogs['enter-password'].viewContent.fields[1].error = $translate.instant('error.validation.empty_password_or_invalid_length_and_char_match', {min: 8});
            $scope.dialogs['enter-password'].viewContent.fields[1].dependencyError = translations['error.validation.passwords_nomatch'];

        });

        $scope.fieldValues = {};

        $scope.$on('actionBar:cancelRequest', function () {
            $state.go('login', {}, {reload: true});
        });

        $scope.negativeAction = function () {
            $state.go('login', {}, {reload: true});
        };

        $scope.changeInProgress = {'active': false};

        if ($stateParams.token) {
            $scope.dialogs['enter-password'].display = 'yes';
            $scope.activeFormName = 'loginForm_2';
        }

        $scope.$on('actionBar:setPassword', function () {
            $scope.changeInProgress.active = true;

            if (!$scope.fieldValues.password || $scope.fieldValues.password !== $scope.fieldValues.passwordRepeat) {
                $scope.changeInProgress.active = false;
                $scope.infoMessages['invalid-input'].display = 'yes';
                return;
            }

            var userData = {
                password: $scope.fieldValues.password,
                passwordRepeat: $scope.fieldValues.passwordRepeat,
                uuid: $location.search()['usr'],
                token: $stateParams.token
            };

            AuthService.verifyUserAccount(userData).then(function (response) {
                if ([200, 201, 204].indexOf(response.status) !== -1) {
                    $scope.dialogs['enter-password'].display = 'no';
                    $scope.infoMessages['password-success'].display = 'yes';
                    $timeout(function () {
                        $scope.infoMessages['password-success'].display = 'no';
                        $state.go('login', {}, {reload: true});
                    }, 5000);
                } else {
                    $scope.infoMessages['server-error'].display = 'yes';
                    $scope.infoMessages['server-error'].content = response.data.message;
                }
            });
        });
    }
}());
;
(function() {
    angular
        .module('seven-admin.auth')
        .directive('passwordMatch', passwordMatch);

    function passwordMatch () {
        return {
            restrict: 'A',
            scope: true,
            require: 'ngModel',
            link: function (scope, elem, attrs, control) {
                var pwdChecker = function () {
                    // get the values of the passwords
                    var pwd1 = scope.$eval(attrs.ngModel),
                        pwd2 = scope.$eval(attrs.passwordMatch);

                    return pwd1 === pwd2;
                };
                scope.$watch(pwdChecker, function (match) {
                    // set the form to valid if passwords are the same, else invalid
                    control.$setValidity('pwmatch', match);
                });
            }
        };
    }
}());
//# sourceMappingURL=seven-admin.auth.js.map